<template>
  <div class="fuller">
    <div class="marginer">
      <h1>
        Welcome to YoEarth Builder.
      </h1>
    </div>
    <div class="row-items">
      <div class="marginer">
        <h1>
          Create a YoEarth.
        </h1>
        <div>
          <div>
            <p>
              Yo Earth Title
            </p>
            <input type="text" v-model="reg.title">
          </div>
          <div>
            <p>
              Username
            </p>
            <input type="text" v-model="reg.username" />
          </div>
          <div>
            <p>
              Email
            </p>
            <input type="text" v-model="reg.email" />
          </div>
          <div>
            <p>
              Password
            </p>
            <input type="password" v-model="reg.password" />
          </div>
          <div>
            <p>Submit</p>
            <button class="btn-cta" @click="submit()">Create Yo Earth</button>
          </div>
          <div>
            <p>
              {{ err }}
            </p>
          </div>
          <div v-if="loading">
            <p>
              Loading...
            </p>
          </div>
        </div>
      </div>
      <div class="separator"></div>
      <div class="marginer">
        <h1>
          Login to Dashbaord
        </h1>
        <div>
          <div>
            <p>
              Username
            </p>
            <input type="text" v-model="auth.username">
          </div>
          <div>
            <p>
              Password
            </p>
            <input type="password" v-model="auth.password" />
          </div>
          <div>
            <p>Submit</p>
            <button class="btn-cta" @click="login()">Login</button>
          </div>
          <div>
            <p>
              {{ errLogin }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as eAPI from '../yoteach2-gui/SubCompos/eAPI.js'
import * as yoAPI from '../yoteach2-gui/parts/YoNetwork/YoNetwork.js'
export default {
  data () {
    return {
      loading: false,
      auth: {
        username: '',
        password: ''
      },
      errLogin: '',
      err: '',
      reg: {
        title: '',
        slug: '',
        username: '',
        email: '',
        password: ''
      }
    }
  },
  methods: {
    async login () {
      this.loggingin = true
      this.errLogin = ''
      let reg = this.auth
      try {
        await eAPI.login({ email: reg.username, password: reg.password })
      } catch (e) {
        this.errLogin = 'Can\'t login'
      }
      this.loggingin = false
      this.$router.push('/dashboard')
    },
    async submit () {
      this.loading = true
      let reg = this.reg
      let myinfo = false
      try {
        let data = await eAPI.register({ username: reg.username, email: reg.email, password: reg.password })
        myinfo = data.user
      } catch (e) {
        this.err = e.message
        this.loading = false
        console.log(e)
        // if (e.message.indexOf('Email is already taken') !== -1) {
        //   try {
        //     let data = await eAPI.login({ email: reg.email, password: reg.password })
        //     myinfo = data.user
        //   } catch (e) {
        //     console.log(e)
        //     return
        //   }
        // } else {
        //   return
        // }

        return
      }
      let earth = await eAPI.createEarth({
        data: {
          title: reg.title,
          desc: '',
          userID: myinfo._id
        }
      })

      let earthSecret = await eAPI.createEarthSecret({
        data: {
          earthID: earth._id,
          earthPassword: reg.password,
          userID: myinfo._id
        }
      })

      console.log(earthSecret)

      let template = {
        title: earth._id,
        desc: '',

        hideFromSearchResult: false,

        enableRoomAdminFeatures: true,
        roomAdminPassword: reg.password,
        roomAdminPasswordRecoveryQuestion: '',
        roomAdminPasswordRecoveryAnswer: '',

        enableRoomEntryPassword: false,
        roomEntryPassword: '',

        sortMethod: 'chat',

        adminUUIDs: [],
        mutedUUIDs: []
      }
      let resp = await yoAPI.createRoom({ ...template })
      let room = resp.data

      let lobby = await eAPI.createYoEarthRoomMeta({
        data: {
          earthID: earth._id,
          roomID: room._id,
          roomTitle: 'Lobby',
          userID: myinfo._id
        }
      })
      this.loading = false
      console.log(lobby)

      this.auth.username = reg.username
      this.auth.password = reg.password

      this.login()
      // API.checkRoomNameTaken({
      //   title: my
      // }).then(() => {
      // })
    }
  }
}
</script>

<style scoped>
.marginer{
  margin: 30px;
}
.row-items{
  display: flex;
  flex-wrap: wrap;
}
.separator{
  border-left: black solid 1px;
  margin-top: 30px;
  height: 500px;
  width: 1px;
}
.btn-cta{
  appearance: none;
  border: black solid 1px;
  padding: 10px 30px;
  font-size: 18px;
  outline: none;
  box-shadow: none;
}
.fuller{
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  padding: 1px;
}
</style>
